export default __webpack_public_path__ + "static/media/shape2.15127d9c.svg";